import React from "react";

import PageWrapper from "../components/PageWrapper";
import ProtectedRoute from "../components/ProtectedRoute";
import StaffingHero from "../sections/landing4/StaffingHero";
import JuniorStaffing from "../sections/tools/JuniorStaffing";
import JuniorStaffingPreview from "../sections/tools/JuniorStaffingPreview";
import CTA from "../sections/landing4/CTA";
import Seo from "../components/Seo";

const StaffingPage = () => (
  <>
    <Seo
      title="Staffing — Senior + Junior DevOps Placement"
      description="Embed a Dioscuro junior into your team. We mentor them in parallel. If they're great, hire them — that's the point."
      pathname="/staffing"
    />
    <PageWrapper>
      <StaffingHero />
      <ProtectedRoute requiredRole="staff" preview={<JuniorStaffingPreview />}>
        <JuniorStaffing />
      </ProtectedRoute>
      <CTA />
    </PageWrapper>
  </>
);

export default StaffingPage;
